import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"pa-0",attrs:{"fluid":""}},[_c(VFlex,{attrs:{"xs12":""}},[_c('full-calendar',{attrs:{"events":_vm.events},on:{"event-selected":_vm.eventSelected,"event-render":_vm.eventRender}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }